// generated from 15 samples

import { z } from "zod";
import { common } from "../common";

export const interactedWithInternalStepTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::InteractedWithInternalStep"),
  eligible_workflow_steps: z.array(
    z.object({
      id: common.objectId,
      value: z.string(),
    })
  ),
  interaction: z.enum([
    "ce", // 9 (60.00%)
    "oe", // 3 (20.00%)
    "ti", // 2 (13.33%)
    "op", // 1 (6.67%)
  ]),
  selected_workflow_step_id: common.objectId,
  selected_workflow_step_name: z.string(),
});
